<template>
  <div id="edit_news">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/bg3.jpg'); height:50vh">
        <div class="container">
            <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                    <h1 class="title">(編輯)最新消息</h1>
                    <h3 class="title description">News</h3>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div class="main">
          <div class="container">
            <div class="progress" style="height: 10px;" v-if="prossVal !=0">
                <div class="progress-bar" role="progressbar" :style="{width: prossVal + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{prossVal}}%</div>
            </div>
            <div class="section">
              <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                  <span class="material-icons mr-2">save_alt</span> 儲存
              </button>
              <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                  <span class="material-icons mr-2">keyboard_return</span> 取消編輯
              </button>
              <button class="btn btn-social btn-fill btn-twitter" @click="add_news">
                <span class="material-icons mr-2">control_point</span> 新增新聞
              </button>
              <template v-for="(item, index) in data">
                <table class="table table-bordered" :key="index">
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle; width:15%">時間</td>
                    <td>
                      <input type="text" class="form-control" v-model="item.time" v-if="item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="item.time" v-else>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">標題</td>
                    <td>
                      <input type="text" class="form-control" v-model="item.title" v-if="item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="item.title" v-else>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">出處</td>
                    <td>
                      <input type="text" class="form-control" v-model="item.prov" v-if="item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="item.prov" v-else>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">標題照片</td>
                    <td>
                      <div v-if="item.del == 0">
                        <img :src="item.title_img" style="width:10%">
                          <label class="btn btn-info">
                              <input type="file" class="custom-file-input" style="display: none;" accept="image/*" @change="uploadImg($event, index, 'title_img')" />
                              <i class="fa fa-photo"></i> 上傳圖片
                          </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">出處照片</td>
                    <td>
                      <div v-if="item.del == 0">
                        <img :src="item.prov_img" style="width:10%">
                        <label class="btn btn-info">
                            <input type="file" class="custom-file-input" style="display: none;" accept="image/*" @change="uploadImg($event, index, 'prov_img')" />
                            <i class="fa fa-photo"></i> 上傳圖片
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">內容</td>
                    <td>
                      <textarea class="form-control" v-model="item.parag" rows="15" v-if="item.del == 0"></textarea>   
                      <textarea class="form-control" v-model="item.parag" rows="15" v-else></textarea>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-secondary title" style="vertical-align: middle;">刪除</td>
                    <td>
                      <button v-if="item.del == 0" class="btn btn-link btn-twitter" @click="list_del(index)">
                        <span class="material-icons mr-2">remove_circle_outline</span> 刪除此標題
                      </button>
                      <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index)">
                        <span class="material-icons mr-2">delete_sweep</span> 取消刪除
                      </button>
                    </td>
                  </tr>
                </table>
              </template>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_news",
  props: [],
  data() {
    return {
      data:[],
      imgFile: [],
      imgNumLimit: 1,
      imgString: [],
      prossVal: 0
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      axios
        .get(`/api/getnews`)
        .then(res => {
          var data = res.data.data
          for(var i = 0; i < data.length; i++){
            vm.data.push({
              id: data[i].id,
              prov: data[i].prov,
              prov_img: data[i].prov_img,
              time: data[i].time,
              title: data[i].title,
              title_img: data[i].title_img,
              parag: data[i].parag,
              del: 0
            })
          }
          
        })
        .catch(err => {
          console.log(err);
        });
    },
    uploadImg: function(e, index, name) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);


              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 1);

              _this.imgString.push({ src: base64 });
              if(name == 'title_img'){
                _this.data[index].title_img = _this.imgString[0].src;
              }
              if(name == 'prov_img'){
                _this.data[index].prov_img = _this.imgString[0].src;
              }
             
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    async save_data(){
      var vm = this;
      var save_data = vm.data;
      for(var i = 0; i < save_data.length; i++){
        await vm.dataSave({
                id: save_data[i].id,
                prov: save_data[i].prov,
                prov_img: save_data[i].prov_img,
                time: save_data[i].time,
                title: save_data[i].title,
                title_img: save_data[i].title_img,
                parag: save_data[i].parag,
                del: save_data[i].del
              })
        // 進度條
        vm.prossVal = Math.floor(( i / save_data.length )*100);
          
      }
      vm.$router.push("news");
      // axios
      //   .post(`${process.env.API_PATH}/api/savenews`,save_data)
      //   .then(res => {
      //     // console.log(res);
      //     if(res.status == 200)
      //         vm.$router.push("news");
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },    
    // 儲存
    async dataSave(save_data){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savenews`,save_data)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    add_news: function(){
      this.data.unshift({
        id: null,
        prov: '',
        prov_img: '',
        time: '',
        title: '',
        title_img: '',
        del: 0
      })
    },
    list_cancel_del: function(index){
      this.data[index].del = 0;
    },
    list_del: function(index){
      this.data[index].del = 1;
    },
    cancel_edit: function(){
      this.$router.push("/news");
    },

  },
  filters: {},
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/edit_news.vue